import { jsx as _jsx } from "react/jsx-runtime";
import { Box, alpha } from '@mui/material';
import { CheckCircle, ErrorOutlined, Info } from '@mui/icons-material';
const getIconColor = (variant) => {
    switch (variant) {
        case 'success':
            return 'success';
        case 'warning':
            return 'warning';
        case 'error':
            return 'error';
        case 'info':
        default:
            return 'info';
    }
};
const getIcon = (variant) => {
    switch (variant) {
        case 'info':
            return Info;
        case 'success':
            return CheckCircle;
        case 'warning':
            return Info;
        case 'error':
            return ErrorOutlined;
        default:
            return null;
    }
};
const ToastSeverityIcon = ({ variant }) => {
    const color = getIconColor(variant);
    const Icon = getIcon(variant);
    if (!Icon) {
        return null;
    }
    return (_jsx(Box, { display: 'flex', alignItems: 'start', ml: -1, mr: 1.5, p: 0.625, borderRadius: '100%', sx: { backgroundColor: (theme) => alpha(theme.palette[color].main, 0.15) }, children: _jsx(Icon, { color: color }) }));
};
export default ToastSeverityIcon;
